// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle the current block state.
   *
   * @object state
   */
  var state = {};

  /**
   * Object to handle the current map instance and data.
   *
   * @object map
   */
  var map = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Set the root block element
      ui.block = dom(".map");

      // Skip if the block element is not present
      if (!ui.block) {
        return;
      }

      // Get references to map search UI elements
      ui.search = {
        form: dom(".map-search form", ui.block),
        label: dom(".map-search label", ui.block),
        input: dom(".map-search input", ui.block),
        button: dom(".map-search button", ui.block),
        loader: dom(".map-search img", ui.block),
      };

      // Get references to map locations list UI elements
      ui.list = {
        wrapper: dom(".map-list", ui.block),
        heading: dom(".map-list h3", ui.block),
        sort: dom(".map-sorting", ui.block),
        items: dom(".map-items", ui.block),
      };

      // Get reference to the map canvas element
      ui.map = dom(".map-canvas", ui.block);

      // Skip if no map element is present
      if (!ui.map) {
        return;
      }

      // Set the initial state for the block
      state.config = {
        data: {
          url: "/wp-content/themes/rgc/blocks/map/data.json",
          options: { idPropertyName: "key" },
        },
        map: {
          options: {
            center: { lat: 48, lng: -85 },
            zoom: 5,
          },
        },
      };

      // Load the maps API and handle the callback
      this.loadMapAPI();

    },

    /**
     * Method to load the map API.
     *
     * @method block.loadMapAPI
     */
    loadMapAPI: function() {

      var script = document.createElement("script");

      // Set the script source using the key from the config
      script.src = [
        "https://maps.googleapis.com/maps/api/js",
        "?key=", config.maps.key,
        "&callback=", "maps.init",
      ].join("");

      // Create a global reference to the map init callback
      window.maps = { init: block.callbackMapAPI };

      // Add the script to the page to load the maps API
      document.body.appendChild(script);

    },

    /**
     * Method to handle the map API loaded callback.
     *
     * @method block.callbackMapAPI
     */
    callbackMapAPI: function() {

      var config = state.config;

      // Create the map, info window and geocoding instances
      map.instance = new google.maps.Map(ui.map, config.map.options);
      map.infowindow =  new google.maps.InfoWindow();
      map.geocoder = new google.maps.Geocoder();

      // Handle both the submit button and the form submit event
      ui.search.button.addEventListener("click", block.searchLocations);
      ui.search.form.addEventListener("submit", block.searchLocations);

      // Load the data from the JSON file and handle the data in the callback
      map.instance.data.loadGeoJson(
        config.data.url,
        config.data.options,
        block.callbackDataLoaded
      );

      // Set generic handler to change the content vs having multiple instances
      map.instance.data.addListener("click", block.setInfoWindow);

    },

    /**
     * Method to format the data for use with the block.
     *
     * @method block.callbackDataLoaded
     */
    callbackDataLoaded: function() {

      state.data = {};

      // Make the data accessible using the lat/lng as an id for easy lookup
      var index = 0;
      map.instance.data.forEach(function(data) {
        var location = data.getGeometry().get();
        var id = [location.lat(), location.lng()].join(",");
        state.data[id] = data;
        index += 1;
      });

      // Render the location list using the formatted data
      block.renderLocationsList();

      // Set the custom marker styles for each marker created from the data
      block.setMarkerStyle();

    },

    /**
     * Method to set the custom map marker style.
     *
     * @method block.setMarkerStyle
     */
    setMarkerStyle: function() {

      map.instance.data.setStyle(function(feature) {
        return {
          icon: {
            url: "/wp-content/themes/rgc/images/icon-map-marker.png",
            size: new google.maps.Size(27, 35),
            scaledSize: new google.maps.Size(27, 35),
          },
        };
      });

    },

    /**
     * Method to set the info window content.
     *
     * @method block.setInfoWindow
     */
    setInfoWindow: function(event) {

      var data = event.feature;
      var position = data.getGeometry().get();
      var attributes = ' target="_blank" describedby="map-info-header" rel="noopener"';

      var url = data.getProperty("website")
      var website = !url ? "" : [
        '<a href="', url, '"', attributes, '>',
          ui.list.items.dataset.labelWebsite,
        '</a>',
      ].join("");

      var lang = document.documentElement.lang;
      var name = lang === "fr" ? data.getProperty("name_fr") : data.getProperty("name");

      var directions = "https://www.google.com/maps/dir/?api=1&destination=" + [
        position.lat(),
        position.lng(),
      ].join(",");

      var content = [
        '<div class="map-info">',
          '<h6 id="map-info-header">', name, '</h6>',
          '<span class="map-location-address">',
            '<div class="map-location-address-details">',
              data.getProperty("street"), '<br>',
              data.getProperty("city"), ', ',
              data.getProperty("province"), ', ',
              data.getProperty("postal"),'<br>',
              data.getProperty("phone"),
            '</div>',
            '<div>',
              website,
              '<a href="', directions, '"', attributes, '>',
                ui.list.items.dataset.labelDirections,
              '</a>',
            '</div>',
          '</span>',
        '</div>',
      ].join("");

      map.infowindow.setContent(content);
      map.infowindow.setPosition(position);
      map.infowindow.setOptions({
        minWidth: window.innerWidth < 1024 ? 175 : 250,
        maxWidth: window.innerWidth < 1024 ? 250 : 400,
        pixelOffset: new google.maps.Size(0, -30),
      });

      map.infowindow.open(map.instance);

    },

    /**
     * Method to search for locations.
     *
     * @method block.searchLocations
     */
    searchLocations: function(event) {

      // Prevent default form submit functionality
      event.preventDefault();

      // Create the address object to input to the geocoder
      var input = { address: ui.search.input.value };

      // Show the loading indicator
      ui.search.loader.style.opacity = 1;

      // Geocode the address to get the coordinates
      map.geocoder.geocode(input, block.callbackGeocodedAddress);

    },

    /**
     * Method to handle the results returned from geocoding the address input.
     *
     * @method block.callbackGeocodedAddress
     */
    callbackGeocodedAddress: function(results, status) {

      var result = results[0];

      if (!result) {
        // Hide the loading indicator
        ui.search.loader.style.opacity = 0;
        // TODO: Display the error unobtrusively in the UI
        window.alert(ui.search.form.dataset.labelError);
        // Set the focus back on the input
        return ui.search.input.focus();
      }

      var location = result.geometry.location;

      // Handle errors returned from the API, if present
      if (status !== "OK") {
        // Hide the loading indicator
        ui.search.loader.style.opacity = 0;
        // Set the focus back on the input
        ui.search.input.focus();
        // Log the error
        return console.error("maps.geocode error", status);
      }

      // Cache the result location
      state.result = [location.lng(), location.lat()];

      // Update the map center and zoom
      map.instance.setCenter(location);
      map.instance.setZoom(12);

      // If a location marker has been created, update the position
      if (state.location) {
        state.location.setPosition(location);
      // Otherwise create the current location custom map marker
      } else {
        state.location = new google.maps.Marker({
          position: location,
          map: map.instance,
          clickable: false,
          icon: {
            url: "/wp-content/themes/rgc/images/icon-map-location.png",
            size: new google.maps.Size(36, 35),
            scaledSize: new google.maps.Size(36, 35),
          },
        });
      }

      // Iterate over the data and calculate the distance from the location
      map.instance.data.forEach(function(data) {
        var location = [
          data.getGeometry().get().lng(),
          data.getGeometry().get().lat(),
        ];
        data.setProperty(
          "distance",
          block.getDistanceBetweenCoords(location, state.result, true)
        );
        block.renderLocationsList();
        // Hide the loading indicator
        ui.search.loader.style.opacity = 0;
      });

    },

    /**
     * Method to render the list of locations.
     *
     * @method block.renderLocationsList
     */
    renderLocationsList: function() {

      // Create a document fragment for appending for improved performance
      var fragment = document.createDocumentFragment();

      // Covert the data to a standard array
      var list = [];
      map.instance.data.forEach(function(data) {
        list.push(data);
      });

      // If rendering the list by distance, sort the data based on distance
      if (state.result) {
        // Update the label
        ui.list.sort.innerHTML = ui.list.sort.dataset.labelDistance;
        // Use a custom sort function to compare distances
        list.sort(function compare(a, b) {
          if (a.getProperty("distance") < b.getProperty("distance")) {
            return -1;
          }
          if (a.getProperty("distance") > b.getProperty("distance")) {
            return 1;
          }
          return 0;
        });
      }

      // Empty the list and scroll to the top
      ui.list.items.innerHTML = "";
      ui.list.wrapper.scrollTop = 0;

      // Render each item to the fragment
      list.forEach(block.renderLocationItem.bind(fragment));

      // Append all items at once using the document fragment
      ui.list.items.appendChild(fragment);

      // Get the new links from the DOM to set click handlers
      var links = doms(".map-location-title", ui.block);
      for (var i = 0; i < links.length; i++) {
        links[i].onclick = function(event) {
          event.preventDefault();
          var id = [this.dataset.lat, this.dataset.lng].join(",");
          block.setInfoWindow({ feature: state.data[id] });
        };
      }

    },

    /**
     * Method to render the individual location item for the list.
     *
     * @method block.renderLocationItem
     */
    renderLocationItem: function(data, index) {

      var item = document.createElement("li");
      var coordinates = data.getGeometry().get();
      var suffix = ui.list.items.dataset.labelDistance;

      var distance = state.result
        ? "<div>~" + data.getProperty("distance") + suffix + "</div>"
        : "";

      var directions = "https://www.google.com/maps/dir/?api=1&destination=" + [
        coordinates.lat(),
        coordinates.lng(),
      ].join(",");

      var attributes = {
        title: [
          ' data-lat="', coordinates.lat(), '"',
          ' data-lng="', coordinates.lng(), '"',
        ].join(""),
        link: [
          ' target="_blank"',
          ' aria-describedby="map-location-heading-', index, '"',
          ' rel="noopener"',
        ].join(""),
      };

      var url = data.getProperty("website")
      var website = !url ? "" : [
        '<a href="', url, '"', attributes.link, '>',
          ui.list.items.dataset.labelWebsite,
        '</a>',
      ].join("");

      var lang = document.documentElement.lang;
      var name = lang === "fr" ? data.getProperty("name_fr") : data.getProperty("name");

      item.innerHTML = [
        '<h4 class="h6" id="map-location-heading-', index, '">',
          '<a class="map-location-title" href="#"', attributes.title, '>',
            name,
          '</a>',
        '</h4>',
        '<span class="map-location-address">',
          data.getProperty("street"), '<br>',
          data.getProperty("city"), ', ',
          data.getProperty("province"), ', ',
          data.getProperty("postal"),'<br>',
          data.getProperty("phone"),
          '<div>',
            website,
            '<a href="', directions, '"', attributes.link, '>',
              ui.list.items.dataset.labelDirections,
            '</a>',
          '</div>',
          distance,
        '</span>',
      ].join("");

      this.appendChild(item);

    },

    /**
     * Method to handle calculating the distance between two coordinates.
     *
     * @see http://www.movable-type.co.uk/scripts/latlong.html
     * @see https://en.wikipedia.org/wiki/Haversine_formula
     *
     * @method block.getDistanceBetweenCoords
     */
    getDistanceBetweenCoords: function(start, end, round) {

      var radius = 6371; // Earth's radius in kilometers (roughly)
      var latitude = block.getRadiansFromDegrees(end[1] - start[1]);
      var longitude = block.getRadiansFromDegrees(end[0] - start[0]);

      var value = Math.sin(latitude / 2) *
        Math.sin(latitude / 2) +
        Math.cos(block.getRadiansFromDegrees(start[1])) *
        Math.cos(block.getRadiansFromDegrees(end[1])) *
        Math.sin(longitude / 2) *
        Math.sin(longitude / 2);

      var calculation = 2 * Math.atan2(
        Math.sqrt(value),
        Math.sqrt(1 - value)
      );

      var distance = radius * calculation;

      return round ? Math.round(distance, 1) : distance;

    },

    /**
     * Method to handle converting degrees to radians.
     *
     * @see http://www.movable-type.co.uk/scripts/latlong.html
     * @see https://en.wikipedia.org/wiki/Haversine_formula
     *
     * @method block.getRadiansFromDegrees
     */
    getRadiansFromDegrees: function(value) {

      return (Math.PI / 180) * value;

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
